var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 688"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    d: "M28.1306 21.8892C28.1306 21.5974 28.0145 21.3057 27.7826 21.0833L20.4827 14.0839C20.0183 13.6387 19.2654 13.6387 18.8013 14.0839C18.3371 14.529 18.3371 15.2508 18.8013 15.6961L25.2606 21.8892L18.8015 28.0823C18.3373 28.5276 18.3373 29.2493 18.8015 29.6943C19.2657 30.1398 20.0185 30.1398 20.4829 29.6943L27.7828 22.695C28.0147 22.4725 28.1306 22.1808 28.1306 21.8892V21.8892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 24583",
    opacity: 0.4,
    x: 1.07812,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "#D9D9D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForward);
export default __webpack_public_path__ + "static/media/iconForward.af0ff1a2d29c1201c2fb0db2d9878d33.svg";
export { ForwardRef as ReactComponent };